import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { useTaishokutodokeFormatData } from '@/composables/format-edit/useTaishokutodokeFormatData'
import LetterExampleSentenceDialog, {
  type LetterExampleSentenceItem
} from '@/components/format-edit/letter/LetterExampleSentenceDialog.vue'

type TextareaField = 'taishokureason' | 'entrySummary' | 'resumeSummary'


export default /*#__PURE__*/_defineComponent({
  __name: 'TaishokutodokeTextareaCard',
  props: {
    currentCardId: null,
    cardId: null,
    title: null,
    description: null,
    fieldKey: null,
    errorKey: null,
    showExamples: { type: Boolean, default: false },
    dialogName: { default: '' },
    sentences: { default: () => [] },
    previewErrors: null
  },
  setup(__props: any) {

const props = __props as { currentCardId?: string, cardId: string, title: string, description: string, fieldKey: TextareaField, errorKey: string, showExamples: boolean, dialogName: string, sentences: LetterExampleSentenceItem[], previewErrors: Record<string, string | undefined> };



const formatData = useTaishokutodokeFormatData()
const dialogVisible = ref(false)

const fieldValue = computed({
  get() {
    const value = formatData[props.fieldKey]
    return typeof value === 'string' ? value : ''
  },
  set(next: string) {
    formatData[props.fieldKey] = next
  }
})

const filteredItems = computed(() => {
  const selectedOccupation = formatData.occupation
  return (props.sentences || []).filter(
    (item) => item.type === selectedOccupation
  )
})

function onSelect(sentences: string) {
  formatData[props.fieldKey] = sentences
}

return { __sfc: true,props, formatData, dialogVisible, fieldValue, filteredItems, onSelect, LetterExampleSentenceDialog }
}

})